import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=6739f06e&"
import script from "./Client.vue?vue&type=script&lang=js&"
export * from "./Client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6739f06e')) {
      api.createRecord('6739f06e', component.options)
    } else {
      api.reload('6739f06e', component.options)
    }
    module.hot.accept("./Client.vue?vue&type=template&id=6739f06e&", function () {
      api.rerender('6739f06e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/offer/Client.vue"
export default component.exports